import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Markdown from "markdown-to-jsx";

import qmul from "../assets/images/qmul.gif";
import pometry from "../assets/images/pomlogo.png";
import ideal from "../assets/images/idealondon.png";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Card } from "@material-ui/core";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faClock,
  faMap,
} from "@fortawesome/free-regular-svg-icons";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  cardSpacing: {
    padding: theme.spacing(5.75),
    "@media screen and (max-width: 500px)": {
      padding: theme.spacing(1.75),
    },
  },
  intro: {
    backgroundColor: "#c6385e",
    color: "#f6e4dd",
    borderRadius: "0px 0px 200px 200px",
    "@media screen and (max-width: 500px)": {
      borderRadius: "0px 0px 100px 100px",
    },
  },
  info: {
    backgroundColor: "transparent",
    boxShadow: "None",
  },
  loc_link: {
    color: "black !important",
  },
  logo_cont: {
    backgroundColor: "white",
    borderRadius: "50px",
    color: "black",
    padding: "10px",
    margin: "10px",
  },
  logo: {
    height: "100px",
    "@media screen and (max-width: 500px)": {
      height: "70px",
    },
    "@media screen and (max-width: 400px)": {
      height: "50px",
    },
  },
}));

function Home() {
  const classes = useStyles();
  const [intro, setIntro] = useState("");

  useEffect(() => {
    import("./home.md")
      .then((res) => {
        fetch(res.default)
          .then((res) => res.text())
          .then((res) => setIntro(res))
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  });

  return (
    <Grid container className={classes.root}>
      <Grid item xs className={classes.item}>
        <Card className={classNames(classes.cardSpacing, classes.intro)}>
          <Grid item xs>
            <Markdown>{intro}</Markdown>
          </Grid>
          <Grid container>
            <Grid item xs className={classes.logo_cont}>
              <span>
                <p>
                  <strong>HOSTED BY:</strong>
                </p>
                <img className={classes.logo} src={qmul} alt={"qmul logo"} />
              </span>
            </Grid>
            <Grid item xs className={classes.logo_cont}>
              <span>
                <p>
                  <strong>SPONSORED BY:</strong>
                </p>
                <img
                  className={classes.logo}
                  src={pometry}
                  alt={"pometry logo"}
                />
              </span>
            </Grid>
          </Grid>
        </Card>
        <Card className={classNames(classes.cardSpacing, classes.info)}>
          <FontAwesomeIcon className="fa" icon={faCalendar} size={"2x"} />
          <p>13 JANUARY 2023</p>
          <FontAwesomeIcon className="fa" icon={faClock} size={"2x"} />
          <p>10am - 5:30pm</p>
          <FontAwesomeIcon className="fa" icon={faMap} size={"2x"} />
          <a
            href={"https://goo.gl/maps/nVz57J6zL1p81wWZ8"}
            className={classes.loc_link}
          >
            <p>IDEALONDON</p>
            <p>69 WILSON STREET</p>
            <p>LONDON</p>
            <p>EC2A 2BB</p>
          </a>
          <img className={classes.logo} src={ideal} alt={"idea london logo"} />
        </Card>
      </Grid>
    </Grid>
  );
}

export default Home;
